var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoDataFound"},[_c('div',{staticClass:"text-center no-data-container"},[_vm._v("\n        No data available\n    ")])])}]

export { render, staticRenderFns }